<p-table styleClass="p-datatable-sm" 
#dt
class="m-2" 
[value]="users" 
[scrollable]="true" 
scrollDirection="both" 
scrollHeight="flex" 
[tableStyle]="{'min-width': '60rem'}"
[globalFilterFields]="['name', 'lastName']"
>
<ng-template pTemplate="caption">
  <div class="flex align-items-center justify-content-between">
      In totale ci sono {{users ? users.length : 0 }} convenzioni.
      <div class="flex gap-1">
        <p-button *ngIf="search !== ''" (onClick)="search = ''; dt.filterGlobal(search, 'contains')" icon="pi pi-filter-slash"></p-button>
        <input pInputText type="text" [(ngModel)]="search" (ngModelChange)="dt.filterGlobal(search, 'contains')" placeholder="Cerca..." />
        <p-button (onClick)="loadAgreements()" icon="pi pi-refresh"></p-button>
        <p-button (onClick)="createNewAgreement()" [disabled]="currentlyEditing !== null" icon="pi pi-plus"></p-button>
      </div>
  </div>
</ng-template>
<ng-template pTemplate="header">
    <tr>
        <th class="py-3 px-1">Azioni</th>
        <th class="py-3 px-1">Tipo</th>
        <th class="py-3 px-1">Ragione sociale</th>
        <th class="py-3 px-1">Titolo</th>
        <th pSortableColumn="name" class="py-3 px-1">Nome <p-sortIcon field="name"></p-sortIcon></th>
        <th pSortableColumn="lastName" class="py-3 px-1">Cognome<p-sortIcon field="lastName"></p-sortIcon></th> <!-- VALUTA SE AGGIUNGERE RUOLO -->
        <th pSortableColumn="email" class="py-3 px-1">Email</th>
        <th class="py-3 px-1">Telefono</th>
        <th class="py-3 px-1">Ruolo</th>
        <th class="py-3 px-1">Descrizione</th>
        <th class="py-3 px-1">Locandina</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-agreement>
    <tr>
        <td class="p-1">
          <div class="actions flex justify-content-start gap-1">
            <p-button *ngIf="agreement.agreementId === currentlyEditing?.agreementId" icon="pi pi-save" (onClick)="modifySubscrber()" severity="success"></p-button>
            <p-button *ngIf="agreement.agreementId === currentlyEditing?.agreementId" icon="pi pi-times" (onClick)="editAgreement(null)" severity="danger"></p-button>
            <p-button *ngIf="agreement.agreementId !== currentlyEditing?.agreementId" icon="pi pi-pencil" (onClick)="editAgreement(agreement)" severity="warning"></p-button>
            <p-button *ngIf="agreement.agreementId !== currentlyEditing?.agreementId" icon="pi pi-trash" (onClick)="removeAgreement(agreement)" severity="danger"></p-button>
            <p-button icon="pi pi-eye" (onClick)="openVsibilityDialog(agreement)"></p-button>
          </div>
        </td>

        <ng-container *ngIf="agreement.agreementId === currentlyEditing?.agreementId">
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.jobType" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.businessName" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.jobTitle" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.name" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.lastName" />
          </td> <!-- ISCRITTO NON VEDRà EMAIL E TELEFONO -->
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.email" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.phone" />
          </td>
          <td class="p-1">
            <input type="text" pInputText [(ngModel)]="agreement.description" />
          </td>
          <td class="p-1">
            <p-button [outlined]="true" (onClick)="op.toggle($event)">{{agreement.notes  | slice:0:14}}...</p-button>
            <p-overlayPanel #op>
                <textarea rows="5" cols="40" pInputTextarea [(ngModel)]="agreement.notes"></textarea>
            </p-overlayPanel>
          </td>
        </ng-container>
        <ng-container *ngIf="agreement.agreementId !== currentlyEditing?.agreementId">
          <td class="p-1">{{agreement.jobType}}</td>
          <td class="p-1">{{agreement.businessName}}</td>
          <td class="p-1">{{agreement.jobTitle}}</td>
          <td class="p-1">{{agreement.name}}</td>
          <td class="p-1">{{agreement.lastName}}</td>
          <td class="p-1">{{agreement.email}}</td>
          <td class="p-1">{{agreement.phone}}</td>
          <td class="p-1">{{agreement.description}}</td>
          <td class="p-1">
            {{agreement.notes  | slice:0:50}}<span *ngIf="agreement.notes !== null && agreement.notes.length > 50">...</span>
          </td>
        </ng-container>
        <td class="p-1">
          <p-button [outlined]="true" icon="pi pi-eye" (onClick)="previewFile(agreement)"></p-button>
          <p-fileUpload 
              chooseIcon="pi pi-search" 
              uploadIcon="pi pi-upload"
              [multiple]="false" 
              [maxFileSize]="6000000"  
              [customUpload]="true" 
              mode="basic"
              (uploadHandler)="onBasicUploadAuto(agreement, $event)">
              <ng-template let-file pTemplate="file">
                  File caricato localmente
              </ng-template>
          </p-fileUpload>
        </td>
    </tr>
</ng-template>
<ng-template pTemplate="summary">
</ng-template>
</p-table>
<p-dialog [visible]="showPreview" [style]="{
        'width': '100%',
        'height': '100%'
    }" [draggable]="false" [modal]="true" [closable]="false">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between flex-wrap gap-1 w-full">
            <div>
                <h3>Visualizza documento</h3>
            </div>
            <p-button icon="pi pi-times" (onClick)="closePreview()" [outlined]="false" [rounded]="true" [text]="true" severity="secondary"></p-button>
        </div>
    </ng-template>
    <ngx-extended-pdf-viewer *ngIf="fileSrc"
        [enablePrint]="false"
        [showToolbar]="false"
        [enableDragAndDrop]="false"
        [handTool]="false"
        [src]="fileSrc">
    </ngx-extended-pdf-viewer>
</p-dialog>
<p-dialog [visible]="!!dialogAgreement" *ngIf="!!dialogAgreement" [draggable]="false" [modal]="true" [closable]="false">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between flex-wrap gap-1 w-full">
            <div>
                <h3>Visibilità convenzione</h3>
            </div>
            <p-button icon="pi pi-times" (onClick)="dialogAgreement = undefined" [outlined]="false" [rounded]="true" [text]="true" severity="secondary"></p-button>
        </div>
    </ng-template>
    <div class="flex flex-column gap-3 pb-3">
      <div style="width:100%" class="flex flex-column justify-content-start">
          <span class="text-start border-round-sm font-bold">Descrizione flag</span>
          <input type="text" pInputText [(ngModel)]="dialogAgreement!.flagDescription" />
      </div>
      
      <div style="width:100%" class="flex flex-column justify-content-start">
          <span class="text-start border-round-sm font-bold">Colore flag</span>
          <p-colorPicker [(ngModel)]="dialogAgreement!.flagColor" [inline]="true"></p-colorPicker>
          <span style="width: 40px; height: 40px; border-radius: 4px;" [style.backgroundColor]="dialogAgreement!.flagColor"></span>
          <input type="text" pInputText [(ngModel)]="dialogAgreement!.flagColor" />
      </div>
      
      <div style="width:100%">
        <p-toggleButton [(ngModel)]="dialogAgreement!.disabled" onLabel="Disabilitato" offLabel="Abilitato"></p-toggleButton>
      </div>
      
      <div style="width:100%">
        <p-toggleButton [(ngModel)]="dialogAgreement!.visible" onLabel="Visibile" offLabel="Non visibile"></p-toggleButton>
      </div>
    </div>
    <div class="flex justify-content-between gap-2 w-full">
        <p-button label="Indietro" (onClick)="dialogAgreement = undefined" icon="pi pi-arrow-left"></p-button>
        <p-button label="Conferma" (onClick)="saveVsibility()"  icon="pi pi-check" [severity]="'success'"></p-button>
    </div>
</p-dialog>
<p-speedDial [model]="items" showIcon="pi pi-chevron-up" hideIcon="pi pi-chevron-down" direction="up" type="linear"></p-speedDial>